import * as internal from "stream";

export interface DonutModel {
    disconnectedEquipsCount: string;
    equipsCount: string;
    productMix: ProductMixModel[];
}

export interface ProductMixModel {
    activityId: string;
    noOfEquips: string;
    percentage: string;
}

export interface PieChartModel {
    name: string;
    value: number;
}

export interface EquipmentsUtilization {
    equipmentsUtilization: EquipmentsUtilizationItem[];
}

export interface EquipmentsUtilizationItem {
    daysUtilization: DaysUtilization [];
    equipCount: string;
    equipmentId: string;
    preferredUnit?: string;
}

export interface DaysUtilization {
    date: string;
    dayNo: string;
    dormancy: string;
    equipCount: string;
    totalHours: string;
    utilization: string;
}

export interface GetUtilizationPayload {
    facilityId: string;
    offset: number;
}

export interface GetUtilizationPayloadOperatingHours {
    facilityId: string;
    offset: number;
    facilityHoursStart: number;
    facilityMinsStart: number;
    facilityHoursEnd: number; 
    facilityMinsEnd: number;
}

export class EquipmentsChartModelItem {
    name: string;
    count: number;
    series: EquipmentsChartModelSeries[];
    preferredUnit: string | undefined;
}

export class EquipmentsChartModelSeries {
    name: string;
    value: number;
    count?: number;
    preferredUnit: string | undefined;
}

export class EquipmentsUtilizationChartModel{
    equipmentsUtilizationChartModel: EquipmentsChartModelItem [] = [];
    constructor(data: EquipmentsUtilization, type:UtilizationType ) {
        data.equipmentsUtilization.forEach(dataItem => {
            let equipmentsUtilizationChartModelItem: EquipmentsChartModelItem = {name: dataItem.equipmentId, series: [], count: Number(dataItem.equipCount), preferredUnit: dataItem.preferredUnit};
            dataItem.daysUtilization.forEach(item => {
                let equipmentsUtilizationChartModelSeries = { name: item.date, value: Number(item[type]), preferredUnit: dataItem.preferredUnit};
                equipmentsUtilizationChartModelItem.series.push(equipmentsUtilizationChartModelSeries)
            });
            this.equipmentsUtilizationChartModel.push(equipmentsUtilizationChartModelItem);
        });
    }
}

export enum UtilizationType {
    Utilization = 'utilization',
    Dormancy = 'dormancy'
}

export class AverageByDayModel {
    reportMap: ReportMap;
    totalEquipmentCount: number;
    usageType: string[];
}

export class ReportMap {
    entry: ReportMapEntry[];
    totalEquipmentCount: number;
}

export class ReportMapEntry {
    key: string;
    value: ReportMapEntryValues;
}

export class ReportMapEntryValues {
    distanceData: string[];
    equipmentCount: number;
    hoursData: string[];
    workoutsData: string[];
    weightsData: string[];
    preferredUnit: string | undefined;
}

export class EquipmentsAverageByDayChartModel{
    equipmentsUtilizationChartModel: EquipmentsChartModelItem [] = [];
    constructor(data: AverageByDayModel, type:AverageByDayType ) {
        data.reportMap.entry.forEach(dataItem => {
            if(dataItem.value[type] != undefined) {
                let equipmentsUtilizationChartModelItem: EquipmentsChartModelItem = {name: dataItem.key, series: [], count: Number(dataItem.value.equipmentCount), preferredUnit: dataItem.value.preferredUnit};
                dataItem.value[type].forEach((item, index) => {
                    let equipmentsUtilizationChartModelSeries = { name: data.usageType[index], value: Number(item), preferredUnit: dataItem.value.preferredUnit};
                    equipmentsUtilizationChartModelItem.series.push(equipmentsUtilizationChartModelSeries)
                });
                this.equipmentsUtilizationChartModel.push(equipmentsUtilizationChartModelItem);
            }
        });
    }
}

export enum AverageByDayType {
    DISTANCE = 'distanceData',
    HOURS = 'hoursData',
    WORKOUT = 'workoutsData',
    WEIGHT = 'weightsData'
}

export class AverageByEquipmentModel {
    statisticsData: StatisticsData [];
    totalEquipmentCount: string;
}

export class StatisticsData {
    activityId: string;
    statsData: StatsData;
}

export class StatsData {
    avgDistance: string;
    avgHours: string;
    avgWorkouts: string;
    avgWeights: string;
    dataCount: string;
    preferredUnit?: string;
}

export class EquipmentsAverageByChartData {
    equipmentsUtilizationChartModel: EquipmentsChartModelSeries [] = [];
    constructor(data: AverageByEquipmentModel, type:AverageByEquipment ) {
        data.statisticsData.forEach(dataItem => {
            let equipmentsUtilizationChartModel: EquipmentsChartModelSeries = { name: dataItem.activityId, value: dataItem.statsData[type] != undefined ? Number(dataItem.statsData[type]) : 0, count: Number(dataItem.statsData.dataCount), preferredUnit: dataItem.statsData.preferredUnit};
            this.equipmentsUtilizationChartModel.push(equipmentsUtilizationChartModel);
        });
    }
}

export enum AverageByEquipment {
    DISTANCE = 'avgDistance',
    HOURS = 'avgHours',
    WORKOUT = 'avgWorkouts',
    WEIGHT = 'avgWeights'
}

export enum DataByType {
    DISTANCE,
    HOURS,
    WORKOUTS,
    WEIGHTS
}

export interface UtilizationFilter {
    value: boolean;
    colour: string;
    type: number;
    count: number;
}

export interface DetailsViewModel{
    statisticsData: StatsData[]
    statisticsDrillDownData: StatsData[]
}

export interface StatsDataModel {
    consoleType?: string;
    connectedEquipCount: string;
    dataCount: string;
    disconnectedEquipCount: string;
    idleEquipCount: string;
    inspectBeltCount: string;
    isInspectBelt: string;
    preferredUnit: string;
    status: string;
    totalDistance: string;
    totalHours: string;
    totalMinutes: string;
    totalTreadMillBeltDistance: string;
    totalTreadMillBeltHours: string;
    totalTreadMillBeltMinutes: string;
    totalTreadMillLiftHours: string;
    totalTreadMillLiftMinutes: string;
    totalWeight: string;
    totalWorkouts: string;
}

export interface StatsData {
    activityId: string;
    bodySerial?: string;
    displayName?: string
    statsData?: StatsDataModel;
    expanded: boolean;
}

export interface DetailsViewDataModel extends StatsData {
    childs?: StatsData[];
    expanded: boolean;
}

export interface IDetailsViewGridData {
    detailsViewGridData: DetailsViewDataModel [];
}

export class DetailsViewGridData implements IDetailsViewGridData{
    detailsViewGridData: DetailsViewDataModel [] = [];
    
    constructor(data: DetailsViewModel) {
        data.statisticsData.forEach(dataItem => {
            let tmp: DetailsViewDataModel = dataItem;
            tmp.childs = [];
            data.statisticsDrillDownData.forEach(item => {
                if(dataItem.activityId === item.activityId) {
                    tmp.childs?.push(item);
                }
            });
            this.detailsViewGridData.push(tmp);
        });
    }
}

export interface DetailedViewHeaders {
    label: string;
    dropdown: boolean;
    drodownOptions?: DetaildViewHeadersOptions[];
}

export enum DetaildViewHeadersOptions {
    TOTAL_DISTANCE = "totalDistance",
    TOTAL_BELT_DISTANCE = "totalTreadMillBeltDistance",
    TOTAL_HOURS= "totalHours",
    TOTAL_BELT_HOURS = "totalTreadMillBeltHours",
    TOTAL_LIFT_HOURS = "totalTreadMillLiftHours"
}


